export default __webpack_public_path__ + "static/funnels-group-aggregation-dark-mode-725d2bdec0020a57be398a50fc0af750.png";